import React from 'react';
import { makeStyles } from '@material-ui/core';
import { bool, func, obj, string, shape, arrayOf } from 'prop-types';
import styles from './styles';
import HorizontalScrollBar from '../../../../../components/HorizontalScrollBar';
import EntityCard from '../EntityCard';

const entityOrder = [
  'APIs',
  'APIGroups',
  'Keys',
  'Certificates',
  'ExpiryToCertificates',
];
export default function EntityScrollBar(props) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const getEntityObj = entityName =>
    props.entities.find(entityObj => entityObj.entity === entityName);
  return (
    <React.Fragment>
      <HorizontalScrollBar scrollEntity="referenceCard">
        {props.entities && props.entities.length > 0 ? (
          <div className={classes.leftBorder} />
        ) : null}
        {entityOrder.map(
          (entityName, id) =>
            getEntityObj(entityName) && (
              <EntityCard
                entityClickTab={props.entityClickTab}
                setActiveTab={props.setActiveTab}
                entity={getEntityObj(entityName)}
                id={id}
                key={entityName}
                disabled={props.disabled}
              />
            ),
        )}
        {props.entities && props.entities.length > 0 ? (
          <div className={classes.rightBorder} />
        ) : null}
      </HorizontalScrollBar>
    </React.Fragment>
  );
}
EntityScrollBar.propTypes = {
  entities: arrayOf(shape({
    key: string,
    value: string,
  })),
  entityClickTab: obj,
  setActiveTab: func,
  disabled: bool,
};
